/**
 * Asynchronously loads the component for SendEmailPage
 */

import { lazyLoad } from 'utils/loadable';

export const SendEmailPage = lazyLoad(
  () => import('./index'),
  module => module.SendEmailPage,
);
